import './video.scss';

class Video {
    constructor (element) {
        this.$video = element;
        this.$videoButton = this.$video.querySelector('[data-video="button"]');
        this.$videoElement = this.$video.querySelector('[data-video="video"]');
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        this.$videoButton.addEventListener('click', () => this.togglePlayPause());
    }

    togglePlayPause () {
        if (this.$videoElement.paused) {
            this.$videoElement.play();
            this.$videoButton.classList.add('icon-pause');
            this.$videoButton.classList.remove('icon-play');
        } else {
            this.$videoElement.pause();
            this.$videoButton.classList.add('icon-play');
            this.$videoButton.classList.remove('icon-remove');
        }
    }
}

export { Video };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$videos = $context.querySelectorAll('[data-video="root"]');

        if ($$videos.length > 0) {
            $$videos.forEach($videos => {
                const video = new Video($videos);
                video.initialize();
            });
        }
    }
});
